.selectInput:disabled,
.selectInput[data-disabled] {
  cursor: not-allowed;
  opacity: 1;
  background-color: inherit;
  color: var(--mantine-color-gray-4);
}

.drawerRoot[data-position="right"],
.drawerRoot[style*="--drawer-justify: flex-end"] {
  --drawer-offset: 0;
  --drawer-top-offset: 60px;
}

.drawerRoot[data-position="right"] .drawerInner,
.drawerRoot[style*="--drawer-justify: flex-end"] .drawerInner {
  top: var(--drawer-top-offset);
  height: calc(100% - var(--drawer-top-offset));
}

.drawerContent[data-position="right"],
.drawerRoot[style*="--drawer-justify: flex-end"] .drawerContent {
  --drawer-size: 500px;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.18), 0 -4px 8px rgba(0, 0, 0, 0.18);
  height: 100%;
}

.drawerBody {
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dateTimePickerRoot {
  position: relative;
  color: var(--mantine-color-gray-8);
  background-color: var(--mantine-color-gray-0);
}

.dateTimePickerInput {
  font-family: "Work Sans";
  min-height: 42px;
}

.dateTimePickerLabel {
  position: absolute;
  pointer-events: none;
  font-size: var(--mantine-font-size-xs);
  margin-left: var(--mantine-spacing-sm);
  padding-left: calc(var(--mantine-spacing-xs) / 2);
  padding-right: calc(var(--mantine-spacing-xs) / 2);
  background-color: white;
  top: -9px;
  z-index: 1;
}
